import { createRoot } from 'react-dom/client';
import AppRoot from '@apps/root';
import { RouterProvider } from '@core-web/providers';

// fetch the root element
const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('No root element found');

const root = createRoot(rootElement);
root.render(
  <RouterProvider>
    <AppRoot />
  </RouterProvider>
);
